import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  SHOW_WELCOME_SCREEN,
  HIDE_WELCOME_SCREEN,
  OPEN_MENU,
  CLOSE_MENU,
  SECTION_SELECT,
} from '../actions/types';
import { layoutShowWelcomeScreenReducer } from './showWelcomeScreen';
import { layoutHideWelcomeScreenReducer } from './hideWelcomeScreen';
import { layoutOpenMenuReducer } from './openMenu';
import { layoutCloseMenuReducer } from './closeMenu';
import { layoutSectionSelectReducer } from './sectionSelect';

export const defaultState = {
  showWelcomeScreen: true,
  isMenuOpen: false,
  section: null,
  previousSection: null,
};

export const layoutReducer = createReducer(defaultState, {
  [SHOW_WELCOME_SCREEN]: layoutShowWelcomeScreenReducer,
  [HIDE_WELCOME_SCREEN]: layoutHideWelcomeScreenReducer,
  [OPEN_MENU]: layoutOpenMenuReducer,
  [CLOSE_MENU]: layoutCloseMenuReducer,
  [SECTION_SELECT]: layoutSectionSelectReducer,
});
